import { makeAutoObservable } from "mobx";
class ProfileStore {
  constructor() {
    makeAutoObservable(this);
  }

  person1 = "imgPerson1";
  person2 = "imgPerson2";
  person3 = "imgPerson3";
  person4 = null;
  person5 = "imgPerson4";
  tempProile = null;
  status = "";
  sidebarList = null;

  updatePerson1(profile) {
    this.person1 = profile;
  }
  updatePerson2(profile) {
    this.person2 = profile;
  }
  updatePerson3(profile) {
    this.person3 = profile;
  }
  updatePerson4(profile) {
    this.person4 = profile;
  }
  updatePerson5(profile) {
    this.person5 = profile;
  }
  updateTempProfile(profile) {
    this.tempProile = profile;
  }

  setProfileStoreToIntialState() {
    this.person1 = "imgPerson1";
    this.person2 = "imgPerson2";
    this.person3 = "imgPerson3";
    this.person4 = null;
    this.person5 = "imgPerson4";
    this.tempProile = null;
    this.status = "";
    this.sidebarList = null;
  }
}

export default new ProfileStore();
